import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.scss';
import tableStyles from './table-cells/styles.module.scss';
import ClientsIcon from './icons/clients.svg';
export var ClientsCounter = function (_a) {
    var clientsNo = _a.clientsNo;
    if (clientsNo <= 0) {
        return null;
    }
    return (_jsxs("div", { className: styles['clients-counter'], children: [_jsx(ClientsIcon, { className: tableStyles['icon-black'] }), _jsxs("span", { children: [clientsNo, "\u00A0", clientsNo === 1 ? 'person' : 'people'] })] }));
};
